import Vue from 'vue';

const constants = {
	PRESENTER_MODE: 'presenterMode',
	START_SCREEN_SHARING: 'startScreenSharing',
	STOP_SCREEN_SHARING: 'stopScreenSharing',
	START_DUPLICATE_SCREEN: 'startDuplicateScreen',
	STOP_DUPLICATE_SCREEN: 'stopDuplicateScreen',
	SPEAKER_NOTES_READY: 'speakerNotesReady',
	UPDATE_SPEAKER_NOTES: 'updateSpeakerNotes',
	AUDIENCE_NOTES_READY: 'audienceNotesReady',
	UPDATE_AUDIENCE_NOTES: 'updateAudienceNotes',
	UPDATE_FONT_SIZE_NOTES: 'updateFontSizeNotes',
	UPDATE_FONT_SIZE_NOTES_WINDOW: 'updateFontSizeNotesWindow',
	SELECT_SLIDE: 'selectSlide',
	IS_SCREEN_SHARING_ACTIVE: 'isScreenSharingActive',
	IS_DUPLICATE_SCREEN_ACTIVE: 'isDuplicateScreenActive'
};

const state = Vue.observable({
	isInstructorWindowActive: false,
	isStudentWindowActive: false,
	isScreenSharingActive: false,
	isDuplicateScreenActive: false
});

export default {
	data() {
		return {
			presenterModeChannel: null
		};
	},
	computed: {
		constants() {
			return constants;
		},
		isInstructorWindowActive() {
			return state.isInstructorWindowActive;
		},
		isStudentWindowActive() {
			return state.isStudentWindowActive;
		},
		isScreenSharingActive() {
			return state.isScreenSharingActive;
		},
		isDuplicateScreenActive() {
			return state.isDuplicateScreenActive;
		}
	},
	methods: {
		setInstructorWindowActive(active) {
			state.isInstructorWindowActive = active;
		},
		setStudentWindowActive(active) {
			state.isStudentWindowActive = active;
		},
		setScreenSharingActive(active) {
			state.isScreenSharingActive = active;
			localStorage.setItem(constants.IS_SCREEN_SHARING_ACTIVE, active);
		},
		setDuplicateScreenActive(active) {
			state.isDuplicateScreenActive = active;
			localStorage.setItem(constants.IS_DUPLICATE_SCREEN_ACTIVE, active);
		},
		initPresenterModeChannel() {
			this.presenterModeChannel = new BroadcastChannel(this.constants.PRESENTER_MODE);
			this.handlePresenterModeChannelEvents();
		},
		handlePresenterModeChannelEvents() {
			this.presenterModeChannel.onmessage = event => {
				const { action } = event.data;

				if (action === this.constants.START_SCREEN_SHARING) this.setScreenSharingActive(true);
				if (action === this.constants.STOP_SCREEN_SHARING) this.setScreenSharingActive(false);
				if (action === this.constants.START_DUPLICATE_SCREEN) this.setDuplicateScreenActive(true);
				if (action === this.constants.STOP_DUPLICATE_SCREEN) {
					this.setDuplicateScreenActive(false);
					if (this.isStudentWindowActive) window.close();
				}
			};
		}
	}
};
